// Shared helpers for the Service Team persona (Dashboard + Tickets report).

export const TICKET_TYPE_LABEL = {
  new_installation: "New Installation",
  repair_maintenance: "Repair / Maintenance",
  amc: "AMC",
  operational_issue: "Operational Issue",
};

export const PROBLEM_STATUSES = ["on_hold", "resolution_support_required"];
export const CLOSED_STATUSES = ["completed", "closed"];

/** % completion = completed sub-activities / total sub-activities (e.g. 1/9 for a
 * New Installation ticket with 9 Phase-4 activities and 1 done). Tickets with no
 * sub-activities (repair/AMC/operational) fall back to a binary 0/100 on status. */
export function ticketCompletionPct(t) {
  const total = t.activities?.length || 0;
  if (total > 0) {
    const done = t.activities.filter((a) => a.status === "completed").length;
    return Math.round((done / total) * 100);
  }
  return CLOSED_STATUSES.includes(t.status) ? 100 : 0;
}

export function ticketActivityCounts(t) {
  const total = t.activities?.length || 0;
  const done = t.activities?.filter((a) => a.status === "completed").length || 0;
  return { done, total };
}

/** A ticket "in problem" is stuck (On Hold / needs resolution support) or has
 * breached its SLA deadline — regardless of status. */
export function isTicketInProblem(t) {
  return PROBLEM_STATUSES.includes(t.status) || t.sla_breached === true;
}

export function monthKey(iso) {
  if (!iso) return null;
  const d = new Date(iso);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
}

export function monthLabel(key) {
  if (!key) return "—";
  const [y, m] = key.split("-");
  return new Date(Number(y), Number(m) - 1, 1).toLocaleDateString("en-IN", { month: "short", year: "2-digit" });
}

export function ageDays(createdISO) {
  if (!createdISO) return 0;
  return Math.max(0, Math.floor((Date.now() - new Date(createdISO).getTime()) / 86400000));
}
